import { connect } from "react-redux";
import Questionnaire from "../components/questionnaire";

const stateToProps = ({ currentTask: { instructionsShown } }) => ({
  showInstructions: !instructionsShown,
});

export default connect(stateToProps)(Questionnaire);
